import { Button, Input, message, Modal, Popconfirm, Select, Space, Table, Tooltip, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import APIService from "../../services/APIService";
import moment from "moment";
import country from "../../data/country";
const { TextArea } = Input;
function PipGridInquiry({ isLoading, whiteLabel }) {
  const apiService = new APIService();
  const [inquiry, setInquiry] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const paginationLimit = 10;

  useEffect(() => {
    fetchList();
  }, [page]);

  const fetchList = () => {
    apiService
      .get(`/leads-enquiry/get?formType=MAKE_MY_PROFIT&page=${page}&limit=${paginationLimit}`)
      .then((res) => {
        if (res?.success) {
          const data = res?.payload?.leads?.map((dt, i) => ({
            index: i + 1,
            date: moment(dt.created_at).format("DD-MM-YYYY"),
            key: dt._id,
            register_as: dt.register_as,
            full_name: `${dt.prefix} ${dt.full_name}`,
            phone_number: dt.phone_number,
            email: dt.email,
            status: dt.status,
            country: dt.country,
            city: dt.city,
          }));
          setInquiry(data);
          setTotalCount(res?.payload?.count || 0);
        }
      })
      .catch((e) => console.log(e));
  };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Register as",
      dataIndex: "register_as",
      key: "register_as",
    },
    {
      title: "Full name",
      dataIndex: "full_name",
      key: "full_name",
      width: 300,
    },
    {
      title: "Phone number",
      key: "phone_number",
      dataIndex: "phone_number",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Country",
      key: "country",
      dataIndex: "country",
    },
    {
      title: "City",
      key: "city",
      dataIndex: "city",
    },
  ];

  return (
    <>
      <Typography.Title level={3} className="page-title">
        Inquiry
      </Typography.Title>
      <div style={{ marginBottom: 25, textAlign: "right" }}>
        <Typography.Text copyable={{ text: `${window.location.hostname}/make-my-profit/inquiry` }}>
          <b>Inquiry Link: </b>
          {window.location.hostname}/make-my-profit/inquiry
        </Typography.Text>
      </div>
      <Table
        pagination={{
          pageSize: paginationLimit,
          current: page,
          total: totalCount,
          onChange: (p) => setPage(p),
        }}
        loading={isLoading}
        columns={columns}
        dataSource={inquiry}
      />
    </>
  );
}
const mapStateToProps = ({ login, loading }) => {
  const { whiteLabel } = login;
  const { isLoading } = loading;
  return { whiteLabel, isLoading };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(PipGridInquiry);
